import { useEffect, useState } from 'react';

const RESIZE_THROTTLE_MS = 100;

export const useBreakpoints = () => {
  const [width, setWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1024,
  );
  const isMobile = width < 768;
  const isTablet = width < 1024;
  const isDesktop = width >= 1024;

  useEffect(() => {
    let throttleTimer: ReturnType<typeof setTimeout> | null = null;

    const handleResize = () => {
      if (throttleTimer) return;

      throttleTimer = setTimeout(() => {
        setWidth(window.innerWidth);
        throttleTimer = null;
      }, RESIZE_THROTTLE_MS);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (throttleTimer) clearTimeout(throttleTimer);
    };
  }, []);

  return { isMobile, isTablet, isDesktop };
};
